import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './DashboardTile.scss';
import {Card} from "reactstrap";
import NavLink from "react-router-dom/es/NavLink";

class DashboardTile extends Component {
  render() {
    return (
      <Card body className="dashboard-tile" style={{borderColor: this.props.color}}>
        <NavLink to={this.props.link}>
          <div className="card-header">
            <i className={'fa fa-' + this.props.icon} style={{color: this.props.color}}/>
            <div>
              <span>{this.props.title}</span>
            </div>
          </div>
        </NavLink>
      </Card>
    );
  }
}

DashboardTile.propTypes = {};

export default DashboardTile;
